module.exports = __webpack_public_path__ + "static/media/file_arrow.8df777a5.svg";